@if (settlement) {
  @if (settlement.status !== settlementStatus.Cancelled && settlement.status !== settlementStatus.Completed) {
    <list-view [selectable]="false" emptyLabel="">
      @if (settlementService.clientBehindPayment(settlement)) {
        <list-item alert statusIcon="exclamation-triangle">
          <p>{{ 'settlement.client-behind-payment-info' | translate }}</p>
        </list-item>
      }
      @if (settlementService.clientAcceptanceOverdue(settlement)) {
        <list-item alert statusIcon="exclamation-triangle">
          <p>{{ 'settlement.client-acceptance-overdue-info' | translate }}</p>
        </list-item>
      }
      @if (settlement.status === settlementStatus.Sent && !settlement.acceptedByClient) {
        <list-item warning statusIcon="exclamation-triangle">
          @if (!settlement.acceptedByClient) {
            <p>{{ 'settlement.sent-to-client-awaiting-accept' | translate }}</p>
          }
        </list-item>
      }
      @if (settlement.acceptedByClient) {
        <list-item success statusIcon="square-check">
          {{ 'settlement.accepted-by-client' | translate }}
        </list-item>
      }
    </list-view>
  }
  <list-view [selectable]="false" emptyLabel="">
    @if (settlement.status === settlementStatus.Completed) {
      <list-item success statusIcon="square-check">
        {{ 'settlement.is-completed' | translate }}
      </list-item>
    }
    @if (settlement.status === settlementStatus.Cancelled) {
      <list-item warning statusIcon="exclamation-triangle">
        {{ 'settlement.is-cancelled' | translate }}
      </list-item>
    }
  </list-view>
}
